import {useMutation, useQueryClient} from '@github-ui/react-query'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
  parseJSONWithBetterErrors,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'

import {useReviewRequestsQuery} from '../components/overview/data/route-queries'
import {useMergeBoxQueryKey} from '@github-ui/mergebox/use-merge-box-query-key'

export type MutationData = {
  reviewerLogin: string
}

type Callbacks = {
  onError?: (error: Error) => void
}

export function useAddSuggestedReviewer({onError}: Callbacks = {}) {
  const {queryKey: reviewRequestsQueryKey} = useReviewRequestsQuery()
  const mergeBoxQueryKey = useMergeBoxQueryKey()
  const apiURL = usePageDataUrl(PageData.addSuggestedReviewer)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: MutationData) => {
      const response = await fetchWithErrorHandling(apiURL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: data,
      })
      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({queryKey: reviewRequestsQueryKey}, {cancelRefetch: false}),
        queryClient.invalidateQueries({queryKey: mergeBoxQueryKey}, {cancelRefetch: false}),
      ])
    },
    onError: (e: Error) => {
      onError?.(e)
    },
  })
}
